import { hasAnalyticsConsent } from "@utils/cookieConsent"

export type DataLayerEvent = Record<string, unknown>

export const getAnalyticsDataLayer = (): any[] | undefined => {
  if (!hasAnalyticsConsent() || typeof window === "undefined") return

  const trackingWindow = window as Window & { dataLayer?: any[] }
  trackingWindow.dataLayer = trackingWindow.dataLayer || []
  return trackingWindow.dataLayer
}

export const pushAnalyticsEvent = (event: DataLayerEvent): boolean => {
  const dataLayer = getAnalyticsDataLayer()
  if (!dataLayer) return false

  dataLayer.push(event)
  return true
}
